<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonalProfile.saveError">
    <template slot="center">
      <el-form
         label-width="20em"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :label-position="labelPosition">

        <section>
          <h4 class="section-title">{{ $t('label.basic') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.title')" prop="personal_title">
              <el-col class="el-col--min-10em" :span="4" :xs="12">
                <el-input v-model="formData.personal_title" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.first_name')" prop="first_name">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input v-model="formData.first_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_name')" prop="last_name">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input v-model="formData.last_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>


            <el-form-item :label="$t('label.date_of_birth')" prop="date_of_birth">
              <el-col class="el-col--min-15em" :span="4">
                <el-date-picker type="date" class="w-100" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :placeholder="$t('label.pick_a_date')" v-model="formData.date_of_birth" :disabled="!edit"></el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.gender')" prop="gender">
              <el-col class="el-col--min-15em" :span="6">
                <el-select v-model="formData.gender" class="w-100" placeholder="Select" :disabled="!edit">
                  <el-option :label="$t('label.male')" value="male"></el-option>
                  <el-option :label="$t('label.female')" value="female"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.person_life_stage_legend') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.life_stage')">
              <el-col  class="el-col--min-17em" :span="6">
                <el-cascader
                   v-model="formData.person_life_stage_id"
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :options="_get(PersonalLifeStages, 'data', [])"
                  :props="{ label: 'title', value: 'id', children: 'SubCategories' }"
                  :show-all-levels="false">
                </el-cascader>
              </el-col>
              <el-col :span="24">
                <div class="el-form-item__help">
                  <p v-html="_markdown.render($t('label.person_life_stage_help'))"></p>
                </div>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.roles') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.primary_role')">
              <el-col class="el-col--min-15em" :span="6">
                <el-select v-model="formData.primary_role_id" class="w-100" :disabled="!edit">
                  <el-option v-for="role in _get(PersonalProfile, 'data.Roles', [])" :label="role.name" :value="role.id" :key="role.id"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.licences') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.professional_id')">
              <el-col class="el-col--min-15em" :span="6">
                <el-input v-model="formData.PersonData.licences_professional_id.value" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.contact') }}</h4>
            <div class="section-items">
            <el-form-item :label="$t('label.email')" prop="email">
              <el-col  class="el-col--min-16em" :span="12" :xs="24">
                <el-input v-model="formData.email" :disabled="true"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.phone')" prop="phone">
              <el-col  class="el-col--min-15em" :span="6">
                <el-input v-model="formData.phone" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <p class="section-help">{{ $t('label.private_information_tips') }}</p>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.regional_settings') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.preffered_language')">
              <el-col  class="el-col--min-17em" :span="6">
                <el-select v-model="formData.language_id" class="w-100" :disabled="!edit" @change="handlePrefferedLanguageChange">
                  <el-option v-for="language in _get(RegionalAndLanguageAll, 'data.Languages', [])"
                    :label="language.native_name"
                    :value="language.id"
                    :key="language.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>


            <el-form-item :label="$t('label.measurement_system')">
              <el-col class="el-col--min-17em" :span="6">
                <el-select v-model="formData.measurement_system_id" class="w-100" :disabled="!edit">
                  <el-option v-for="measurementSystem in _get(RegionalAndLanguageAll, 'data.MeasurementSystems', [])"
                    :label="measurementSystem.name"
                    :value="measurementSystem.id"
                    :key="measurementSystem.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.time_zone')">
              <el-col class="el-col--min-17em" :span="8">
                <el-cascader
                   v-model="formData.time_zone_id"
                   class="w-100"
                  :disabled="!edit"
                  :filterable="true"
                  :options="_get(RegionalAndLanguageAll, 'data.TimeZones', [])"
                  :props="{ label: 'title', value: 'id', children: 'Zones' }"
                  :show-all-levels="true">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.address') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.street')" prop="street">
              <el-col :span="14">
                  <el-input v-model="formData.PersonData.address_street.value" :placeholder="$t('label.street')" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="6" :offset="1">
                  <el-input v-model="formData.PersonData.address_house_no.value" :placeholder="$t('label.house_no')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.city')" prop="city">
              <el-col :span="14">
                <el-input v-model="formData.PersonData.address_city.value" :placeholder="$t('label.city')" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-input v-model="formData.PersonData.address_zip.value" :placeholder="$t('label.zip')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.country')">
              <el-col  class="el-col--min-17em" :span="8">
                <el-cascader
                   v-model="formData.region_id"
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                  :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                  :show-all-levels="false">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <!--
        <section v-if="personIsProfessional">
          <h4 class="section-title">{{ $t('label.region_and_language_avability') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.available_in_the_regions')">
              <el-col class="el-col--min-17em" :span="8">
                <el-select v-model="formData.available_regions_id" class="w-100" :multiple="true" filterable :disabled="!edit">
                  <el-option-group
                     v-for="group in _get(RegionalAndLanguageAll, 'data.Regions', [])"
                    :key="group.id"
                    :label="group.title">
                    <template v-for="subGroup in group.SubRegions">
                      <el-option v-for="region in subGroup.SubRegions"
                        :label="region.title"
                        :value="region.id"
                        :key="region.id">
                      </el-option>
                    </template>
                  </el-option-group>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('label.spoken_languages')">
              <el-col class="el-col--min-17em" :span="8">
                <el-select v-model="formData.spoken_language_id" class="w-100" :multiple="true" :disabled="!edit">
                  <el-option v-for="language in _get(RegionalAndLanguageAll, 'data.Languages', [])"
                    :label="language.native_name"
                    :value="language.id"
                    :key="language.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </div>
        </section>
        -->


      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm('formData')">
            {{ $t('label.save_changes') }}
        </el-button>
        <el-button type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { pick, assign, has, last, omitBy, isNil, get, merge, cloneDeep, unset, find } from 'lodash';

import { removeEmpty } from 'utils';
import { validateDate, validatePhoneE164 } from 'helpers';

import { INSTANCE_OWNER } from 'constants/roles';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-my-preferences-personal',
  mixins: [FormStandardBehavior],
  props: {
    PersonalProfile: {
      required: true,
      default: null,
    },
    PersonalLifeStages: {
      required: true,
      default: null,
    },
    RegionalAndLanguageAll: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    labelPosition: {
      required: false,
      default: 'right',
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    personIsProfessional: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        personal_title: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        gender: null,
        email: null,
        phone: null,
        region_id: [],
        person_life_stage_id: [],
        time_zone_id: [],
        language_id: null,
        measurement_system_id: null,
        primary_role_id: null,
        // spoken_language_id: [],
        // available_regions_id: [],
        PersonData: {
          address_street: {
            section: 'address',
            key: 'street',
            value: null,
          },
          address_house_no: {
            section: 'address',
            key: 'house_no',
            value: null,
          },
          address_city: {
            section: 'address',
            key: 'city',
            value: null,
          },
          address_zip: {
            section: 'address',
            key: 'zip',
            value: null,
          },
          licences_professional_id: {
            section: 'licences',
            key: 'professional_id',
            value: null,
          },
        },
      },
    };
  },
  computed: {
    rules() {
      return {
        first_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.first_name', true),
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.last_name', true),
            trigger: 'blur',
          },
        ],
        date_of_birth: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.date_of_birth', true),
            trigger: 'blur',
          },
          {
            validator: validateDate,
            message: this.formatValidationMessage('validation.invalid_date'),
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.gender', true),
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: this.isInstanceOwner(),
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.phone', true),
          },
          {
            trigger: 'blur',
            validator: this.validatePhone,
            message: this.formatValidationMessage('validation.invalid', 'label.phone_format', true),
          },
        ],
      };
    },
  },
  methods: {
    handlePrefferedLanguageChange(id) {
      const languages = get(this.RegionalAndLanguageAll, 'data.Languages', []);
      const preffered = find(languages, { id });
      if (preffered) this.$locale.change(preffered.code);
    },
    cancelChanges() {
      this.$nextTick(() => {
        if (this.$refs[this.formRef]) this.$refs[this.formRef].clearValidate();
      });
      this.formData = this.cloneDeep(this.originalData);

      this.handlePrefferedLanguageChange(this.formData.language_id);

      this.$emit('update:edit', false);
      this.$emit('cancel');
    },
    setFormData() {
      if (has(this.PersonalProfile, 'data.id')) {
        assign(
          this.formData,
          pick(omitBy(this.PersonalProfile.data, isNil), [
            'personal_title',
            'first_name',
            'last_name',
            'email',
            'date_of_birth',
            'phone',
            'gender',
            'region_id',
            'person_life_stage_id',
            'primary_role_id',
            'language_id',
            'time_zone_id',
            'measurement_system_id',
          ]),
        );

        merge(this.formData.PersonData, get(this.PersonalProfile, 'data.PersonData', {}));
        this.originalData = cloneDeep(this.formData);
      }
    },
    getFormData() {
      const copy = cloneDeep(this.formData);
      const data = removeEmpty(copy);

      // TODO: Issue http://jira.laboratony.com/projects/NA/issues/NA-19
      // TODO: Implement change preffered language

      // Remove email
      unset(data, 'email');

      if (has(data, 'person_life_stage_id')) data.person_life_stage_id = last(data.person_life_stage_id);
      if (has(data, 'time_zone_id')) data.time_zone_id = last(data.time_zone_id);
      if (has(data, 'region_id')) data.region_id = last(data.region_id);

      return data;
    },
    validatePhone(rule, value, callback) {
      if (!validatePhoneE164(value)) return callback(new Error());
      return callback();
    },
    isInstanceOwner() {
      const roles = get(this.PersonalProfile, 'data.Roles', []);
      return find(roles, role => role.scope === INSTANCE_OWNER);
    },
  },
  created() {
    this.stateData = this.PersonalProfile;
    this.formRef = 'form-my-preferences-personal';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/personal/form-my-preferences-personal.vue